__turbopack_context__.v({
  "content": "Shortnews-module-scss-module__31k5ra__content",
  "homepageLink": "Shortnews-module-scss-module__31k5ra__homepageLink",
  "links": "Shortnews-module-scss-module__31k5ra__links",
  "list": "Shortnews-module-scss-module__31k5ra__list",
  "player": "Shortnews-module-scss-module__31k5ra__player",
  "timestamp": "Shortnews-module-scss-module__31k5ra__timestamp",
  "titlePrimary": "Shortnews-module-scss-module__31k5ra__titlePrimary",
});
